import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import decorationEllipse from "../../../../assets/landing/feature-decoration-ellipse.png";
import decorationEllipseMob from "../../../../assets/landing/section-decor-ellipse-mob.png";
import { motion } from "framer-motion";

type ContainerProps = {
  sectionClasses?: string;
  containerClasses?: string;
  ellipseClasses?: string;
  children: React.ReactNode;
  animationControls?: any;
};

const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({
  children,
  sectionClasses = "",
  containerClasses = "",
  ellipseClasses = "",
  animationControls,
}) => {
  return (
    <motion.section
      className={clsx(sectionClasses)}
      initial="hidden"
      animate={animationControls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 1, ease: "easeOut", staggerChildren: 0.2 },
        },
      }}
    >
      <div
        className={clsx(
          "max-lg:px-[3.2vw] px-[5.05vw] relative",
          containerClasses
        )}
      >
        <motion.img
          src={decorationEllipse}
          alt="decoration ellipse"
          className={clsx(
            "absolute left-1/2 -top-[35%] -translate-x-1/2 max-lg:hidden pointer-events-none",
            ellipseClasses
          )}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 2 }}
        />

        <motion.img
          src={decorationEllipseMob}
          alt="decoration ellipse"
          className="absolute inset-0 scale-150 lg:hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 2 }}
        />

        {children}
      </div>
    </motion.section>
  );
};

export default Container;
